import React from 'react'

const TAM = 'T&M'
const MANAGED = 'Managed'
const InvoicingReportContext = React.createContext()

export { TAM, MANAGED, InvoicingReportContext }
